import { useState, useEffect } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../sounds/correctAnswerBling.wav'
import wrongAnswerBuzz from '../sounds/wrongAnswerBuzz.wav'
import failSound from '../sounds/fail.mp3'
import arvontaTune from '../sounds/arvontaTune.mp3'
import drumroll from '../sounds/drumroll.mp3'
import slap from '../sounds/slap.mp3'
import Button from 'react-bootstrap/Button';
import { data } from '../data/data_noppa'
import d1 from '../images/d1.gif'
import d2 from '../images/d2.gif'
import d3 from '../images/d3.gif'
import d4 from '../images/d4.gif'
import d5 from '../images/d5.gif'
import d6 from '../images/d6.gif'
import dice_rolling from '../images/dice_rolling.gif'


const Noppa = ({ soundsOn, handlaa, tarvittavaNopanArvo, sulku }) => {

    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);
    const [playSlap] = useSound(slap);
    const [playFailSound] = useSound(failSound);

    const [teksti, setTeksti] = useState('')
    const [rolled, setRolled] = useState(false)//nopat
    const [diceRolling, setDiceRolling] = useState(true)
    const [diceResult, setDiceResult] = useState(null)

    // const [audio] = useState(new Audio(arvontaTune));
    const [audio] = useState(new Audio(drumroll));
    const [playing, setPlaying] = useState(soundsOn);//onko äänet päällä aluksi vai ei

    useEffect(() => {
        setTeksti(data.teksti)
    }, [])


    useEffect(() => {
        playing ? audio.play() : audio.pause();
    },
        [playing]
    );

    useEffect(() => {
        if (soundsOn) {
            if (diceResult < tarvittavaNopanArvo) {
                playFailSound()
            }// playSlap()
            else playCorrectAnswer()
        }
        if (null != diceResult) {
            handlaa(diceResult)
        }

    },
        [diceResult]
    );

    const rollDice = () => {

        if (!playing && soundsOn) {
            setPlaying(true)
        }

        setDiceRolling(true)
        setRolled(true)
    }


    const showDiceResult = () => {

        // if (soundsOn) {
        //     // playSlap()
        //     playSlap()
        // }

        if (playing) {
            setPlaying(false)
        }
        setDiceRolling(false)
        setDiceResult(Math.floor(Math.random() * (6 - 1 + 1)) + 1)
        // sulku()
    }



    return (

        // <div id='nopanId' className='noppa_container'>
        <div id='nopanId' className='noppa_container'>

            {diceRolling ? <img src={dice_rolling} alt='kuva' style={{ width: '250px' }} id='rollingDie' /> : null}

            {!diceRolling && diceResult == '1' ? <img src={d1} alt='d1' /> : null}
            {!diceRolling && diceResult == '2' ? <img src={d2} alt='d2' /> : null}
            {!diceRolling && diceResult == '3' ? <img src={d3} alt='d3' /> : null}
            {!diceRolling && diceResult == '4' ? <img src={d4} alt='d4' /> : null}
            {!diceRolling && diceResult == '5' ? <img src={d5} alt='d5' /> : null}
            {!diceRolling && diceResult == '6' ? <img src={d6} alt='d6' /> : null}

            <br />
            {/* <h5>{(teksti != null && teksti != "") ? teksti : null}</h5> */}
            {tarvittavaNopanArvo ? "saatava vähintään: " + tarvittavaNopanArvo : null}
            <br />

            {diceResult != '' ? 'tulos: ' + diceResult : null}



            <div>
                <Button disabled={!diceRolling} onClick={() => showDiceResult()}>Näytä tulos</Button>
            </div>
        </div>
    )

}


export default Noppa